import { TagERP, TagType } from "@finanedi.es/storybook"
import {
  ORIGEN_DOCUMENTO_ENUM,
  OrigenDocumentoEnumType,
} from "api/Types/OrigenDocumentoEnum"
import { TFunction } from "i18next"

type EstadoProperties = {
  color: TagType
  text: string
}

export const EstadoOrigenFactura = ({
  origen,
  id,
  t,
}: {
  origen: OrigenDocumentoEnumType | undefined
  id?: string
  t: TFunction
}) => {
  const getEstadoOrigen = (): EstadoProperties | undefined => {
    switch (origen) {
      case ORIGEN_DOCUMENTO_ENUM.OPS:
        return {
          color: "gray",
          text: t("crear.factura.origin.opsLabel"),
        }
      case ORIGEN_DOCUMENTO_ENUM.ERP:
        return {
          color: "primary",
          text: t("crear.factura.origin.finanediLabel"),
        }
      case ORIGEN_DOCUMENTO_ENUM.OCR:
        return {
          color: "gray",
          text: t("crear.factura.origin.ocrLabel"),
        }
      case ORIGEN_DOCUMENTO_ENUM.INTEGRACION_SAGE:
        return {
          color: "emerald",
          text: t("crear.factura.origin.sageLabel"),
        }
      case ORIGEN_DOCUMENTO_ENUM.ERP_IMPORTACION_EXCEL:
        return {
          color: "green",
          text: t("crear.factura.origin.excelLabel"),
        }
      case ORIGEN_DOCUMENTO_ENUM.ERP_IMPORTACIONFACTURAE:
        return {
          color: "lime",
          text: t("crear.factura.origin.facturaELabel"),
        }
      default:
        return undefined
    }
  }

  const estadoOrigen = getEstadoOrigen()

  return estadoOrigen ? (
    <div className='tw-flex tw-justify-center tw-items-center !tw-w-full'>
      <TagERP
        id={id}
        value={estadoOrigen.text}
        color={estadoOrigen.color}
      />
    </div>
  ) : (
    <p className='tw-text-center'>-</p>
  )
}
